import React from "react";

import { TitleInput } from "@/pages/shared/TitleInput";

export interface ProgramNameFieldProps {
    /** The current program-name value (controlled). */
    value: string;
    /** Fired with the next value on each keystroke. */
    onChange: (next: string) => void;
}

/**
 * ProgramNameField — the editable draft program-name input in the create
 * flow's title block. A bordered field sized to hold a long program name
 * without pushing the status badge to the edge; the input renders in the
 * bold display size used for the program title.
 *
 * Domain Component: it names a Program's title. One consumer (the client
 * Programs create flow), so it's colocated here as a folder-per-component
 * rather than lifted to shared. Pure controlled View — value in, change
 * out, no data hooks. The field itself is the shared `TitleInput`.
 *
 * @see ProgramNameField.intent.md   policy + recipes
 * @see ProgramNameField.layout.html intended layout
 */
export function ProgramNameField({
    value,
    onChange
}: ProgramNameFieldProps): React.ReactElement {
    // Draft name is the user-written title: the shared title-scale input,
    // the same field the Add Member page names its member in.
    return (
        <TitleInput
            value={value}
            onChange={onChange}
            placeholder="Program Name"
            aria-label="Program name"
        />
    );
}
